import { render, staticRenderFns } from "./NewPromo.vue?vue&type=template&id=c5e7aacc&scoped=true&"
import script from "./NewPromo.vue?vue&type=script&lang=js&"
export * from "./NewPromo.vue?vue&type=script&lang=js&"
import style0 from "./NewPromo.vue?vue&type=style&index=0&id=c5e7aacc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e7aacc",
  null
  
)

export default component.exports